export default {
    /**
     * Set the space data
     *
     * @param state
     * @param space
     */
    setSpace(state, space) {
        Object.keys(space)
            .filter((key) => state.data[key] !== undefined)
            .forEach((key) => {
                state.data[key] = space[key];
            });
    },
};
